import { TCountriesResponse } from "../models/countries";
import { TCountry } from "../types";

const mapCountriesResponse = (countriesResponse: TCountriesResponse): TCountry[] =>
  (countriesResponse || []).map((country) => ({
    code: country.code!,
    title: country.title!,
    isDefault: country.default,
  }));
export default mapCountriesResponse;
